import { Component, Input, ViewEncapsulation } from '@angular/core';
import * as ActionCable from '@rails/actioncable';
import { CloseOverlayKeyboardDirective, CloseOverlayClickDirective } from '../../directives/close-overlay.directives';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-dismiss-confirm',
  styleUrls: ['dismiss-confirm.component.scss'],
  templateUrl: 'dismiss-confirm.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CloseOverlayKeyboardDirective, TranslateModule, CloseOverlayClickDirective]
})
export class DismissConfirmComponent {
  @Input() channel: ActionCable.Channel;

  exit() {
    this.channel.perform('rebroadcast', { error: 'learner_dismissed' });
  }
}
